export default __webpack_public_path__ + "static/media/project2.fd5f7d0b.png";